import { render, staticRenderFns } from "./VaccineList.vue?vue&type=template&id=a5ef5d34&scoped=true&"
import script from "./VaccineList.vue?vue&type=script&lang=js&"
export * from "./VaccineList.vue?vue&type=script&lang=js&"
import style0 from "./VaccineList.vue?vue&type=style&index=0&id=a5ef5d34&lang=scss&scoped=true&"
import style1 from "./VaccineList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ef5d34",
  null
  
)

export default component.exports